<template>
    <div class="page-404">
        <div class="page-content">
            <header class="page-header">
                <div class="page-header-logo">
                    <img
                        src="@/assets/images/business_and_food_lovers_club.svg"
                        alt="Business & Food Lovers Club"
                    />
                </div>
            </header>
            <div class="page-index-body">
                <div class="typo text-center">
                    <h1 >
                        Przepraszamy ale wybrana strona nie istnieje.
                    </h1>
                    <hr/>
                    <p>
                        <img src="@/assets/images/logo.png" alt="makro.pl" /><br>
                        <a href="https://www.makro.pl" target="_blank" rel="noopener" >
                            www.makro.pl
                        </a>

                    </p>
                </div>
            </div>

            <img
                class="footer-logo"
                src="~@/assets/images/corner_logo.svg"
                alt="Makro - Twój sukces to nasz biznes"
            />
        </div>
        <CampaignBackground />
    </div>
</template>

<script>

    import CampaignBackground from '@/components/page/campaign/CampaignBackground'
    export default {
        name: 'Error404',
        components: {
            CampaignBackground
        },
        mounted() {
            this.$store.commit('setLoading', false)
        }
    }
</script>

<style lang="scss">
    @import "src/assets/scss/_variables/screen";

    .page-404 {
        .footer-logo {
            position: absolute;
            bottom: 0;
            right: 0;
        }

        @media (max-width: 960px) {
            .page-content {
                padding: 0 50px 60px;
            }
        }
        @media (max-width: $screen-small-tablet) {
            .page-content {
                padding: 0 0 60px;
            }
            &-body {
                h1, h2 {
                    text-align: center;
                }
            }
        }
    }

</style>
